<style scope>
.w-80px {
    min-width: 80px !important;
}

.w-100px {
    min-width: 100px !important;
}

.w-120px {
    min-width: 120px !important;
}

.w-150px {
    min-width: 150px !important;
}

.w-200px {
    min-width: 200px !important;
}

.w-250px {
    min-width: 250px !important;
}

.scroll-area {
    position: relative;
    margin: auto;
    width: 1300px;
    height: 300px;
}

.table-responsive {
    height: 390px;
}

#tblOrder.table>tbody>tr {
    height: 50px !important;
}
</style>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body pb-0">
                        <!-- <div class="card-title h3 pb-2 mt-0">ค้นหา</div> -->
                        <form action="" class="" @submit.prevent="validateForm" novalidate ref="frmSubmit">
                            <div class="row d-flex align-items-end">

                                <FormInput name="InsuranceId" type="select" label="บริษัทประกัน"
                                    v-model="filter.InsuranceId" placeholder="บริษัทประกัน" :require-field="false"
                                    @validate="validate" :option-datas="MasterInsuranceComp" :error="errors.InsuranceId"
                                    formGroupClass="form-group col-xl-2 col-lg-4 col-sm-6" />

                                <FormInput name="ContractPolicy" type="text" label="เลขกรมธรรม์"
                                    v-model="filter.ContractPolicy" placeholder="เลขกรมธรรม์" @validate="validate"
                                    :error="errors.ContractPolicy" :requireField="false"
                                    formGroupClass="form-group col-xl-2 col-lg-4 col-sm-6" />

                                <FormInput name="Firstname" type="text" label="ชื่อผู้เอาประกัน"
                                    v-model="filter.Firstname" placeholder="ชื่อผู้เอาประกัน" @validate="validate"
                                    :error="errors.Firstname" :requireField="false"
                                    formGroupClass="form-group col-xl-2 col-lg-4 col-sm-6" />

                                <FormInput name="Lastname" type="text" label="นามสกุลผู้เอาประกัน"
                                    v-model="filter.Lastname" placeholder="นามสกุลผู้เอาประกัน" @validate="validate"
                                    :error="errors.Lastname" :requireField="false"
                                    formGroupClass="form-group col-xl-2 col-lg-4 col-sm-6" />

                                <div class="col-xl-4 col-lg-8 col-sm-12 d-inline-flex mt-2">
                                    <b-form-checkbox id="IsInsuranceTypeOrdinary" v-model="filter.InsuranceTypeOrdinary"
                                        name="IsInsuranceTypeOrdinary" value="Y" class="pb-3 mr-2" unchecked-value="N">
                                        งานสามัญ
                                    </b-form-checkbox>

                                    <b-form-checkbox id="IsInsuranceTypeGroup" v-model="filter.InsuranceTypeGroup"
                                        name="IsInsuranceTypeGroup" value="Y" class="pb-3 mr-2" unchecked-value="N">
                                        งานกลุ่ม
                                    </b-form-checkbox>
                                    <b-form-checkbox id="IsIncludedExpired" v-model="filter.IsPendingStatus"
                                        name="IsPendingStatus" value="Y" class="pb-3" unchecked-value="N">
                                        เฉพาะงานที่กำลังดำเนินการ
                                    </b-form-checkbox>
                                </div>

                                <FormInput name="DateCriteria" type="select" label="วันที่ แจ้งงาน/คุ้มครอง/คืนคอมฯ/งวดถัดไป"
                                    v-model="filter.DateCriteria" placeholder="วันที่ แจ้งงาน/คุ้มครอง/คืนคอมฯ"
                                    :require-field="true" @validate="validate" :option-datas="MasterDateCriteria"
                                    :error="errors.DateCriteria"
                                    formGroupClass="form-group col-xl-4 col-lg-4 col-sm-6" />

                                <FormDate name="DateStart" type="date" label="วันที่เริ่มต้น" v-model="filter.DateStart"
                                    placeholder="วันที่จ่ายเงิน" @validate="validate" :error="errors.DateStart"
                                    :require-field="true" formGroupClass="form-group col-xl-2 col-lg-4 col-sm-6" />

                                <FormDate name="DateEnd" type="date" label="ถึงวันที่สิ้นสุด" v-model="filter.DateEnd"
                                    placeholder="ถึงวันที่จ่ายเงิน" @validate="validate" :error="errors.DateEnd"
                                    :require-field="true" formGroupClass="form-group col-xl-2 col-lg-4 col-sm-6" />

                                <FormInput name="NextDueDateIn" type="select" label="ครบชำระงวดถัดไปใน"
                                    v-model="filter.NextDueDateIn" placeholder="ครบชำระงวดถัดไปใน" @validate="validate"
                                    :option-datas="dataDueDateIn" :error="errors.NextDueDateIn" :requireField="false"
                                    formGroupClass="form-group col-sm-2" />
                            </div>

                            <div class="row">
                                <div class="form-group col-sm-12">
                                    <button type="button" class="btn btn-primary" :disabled="isDownload"
                                        @click="submitReqSum" v-show="checkPermission(['ReadJob'])">
                                        <b-spinner v-if="isDownloadReqSum" small></b-spinner>
                                        <i v-else class="fe-search"></i>
                                        ค้นหา
                                    </button>
                                    <button type="button" class="btn btn-secondary ml-2" :disabled="isDownload"
                                        @click="submitDownload" v-show="checkPermission(['ReadJob'])">
                                        <b-spinner v-if="isDownload" small></b-spinner>
                                        <i v-else class="fe-download"></i>
                                        Download Excel
                                    </button>
                                </div>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </div>

        <div class="row" v-show="reqSumData.TotalSum != null">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">

                        <div class="row">
                            <div class="col-12">
                                <div class="table-responsive mb-1">
                                    <!-- Table -->
                                    <table id="tblOrder" class="table table-sm table-centered table-striped border mt-0"
                                        style="width: 1400px">
                                        <thead>
                                            <th class="text-center">ลำดับ</th>
                                            <!-- <th class="text-center">รหัสผู้แจ้งงาน</th>
                                            <th class="text-center">ชื่อตัวแทน</th> -->
                                            <th class="text-center">ประเภท</th>
                                            <th class="text-center">สถานะ</th>
                                            <th class="text-left">กรมธรรม์</th>
                                            <th class="text-left">แผน</th>
                                            <th class="text-left">บริษัทประกัน</th>
                                            <th class="text-left">ชื่อลูกค้า</th>
                                            <th class="text-center">เบี้ยประกันรวม</th>
                                            <th class="text-center">งวดการชำระเบี้ย</th>
                                            <th class="text-center">ปี/งวด ที่ชำระ</th>
                                            <!-- <th class="text-center">งวดที่ชำระ</th> -->
                                            <th class="text-center">
                                                {{ filter.IsPendingStatus == 'Y' ? 'วันที่แจ้งงาน' : 'วันที่ชำระเงิน' }}
                                            </th>
                                            <th class="text-center">งวดถัดไป</th>
                                            <th class="text-center text-nowrap">วันที่ กธ. มีผลคุ้มครอง</th>
                                            <th class="text-center">อนุมัติยอดปรับระดับ</th>
                                            <th class="text-center">ผลประโยชน์ (หลังหักภาษี)</th>
                                            <th class="text-center">วันคืนผลประโยชน์</th>
                                            <th class="text-center">เลขที่พัสดุจัดส่งกรมธรรม์</th>
                                            <th class="text-center text-wrap">ค่าบริหารทีมงาน / รายละเอียด</th>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(row, idx) of Data" :key="idx">
                                                <td class="w-50px text-center">{{ idx + 1 }}</td>
                                                <!-- <td class="w-100px text-center">{{ row.AgentId }}</td>
                                                <td class="w-200px text-center">{{ row.AgentTxt }}</td> -->
                                                <td class="w-80px text-center">{{ row.OrderType }}</td>
                                                <td class="w-80px text-center">{{ row.OrderStatus }}</td>
                                                <td class="w-100px text-left">{{ row.ContactPolicyNumber }}</td>
                                                <td class="w-200px text-left">{{ row.Plan }}</td>
                                                <td class="w-150px text-left">{{ row.InsuranceTxt }}</td>
                                                <td class="w-150px text-left">{{ row.Firstname }} {{ getFirst1Str(row.Lastname) }}
                                                </td>
                                                <td class="w-100px text-center">{{ moneyFormatFull(row.PaymentAmount) }}
                                                </td>
                                                <td class="w-100px text-center">{{ row.PaymentTypeTxt }}</td>
                                                <td class="w-100px text-center">{{ row.Year }}/{{ row.PaymentTime }}
                                                </td>
                                                <!-- <td>{{ row.PaymentTime }}</td> -->
                                                <td class="w-100px text-center">{{ dateFormat(row.CreatedAt) }}</td>
                                                <td class="w-100px text-center">{{ dateFormat(row.NextDueDate) }}</td>
                                                <td class="w-100px text-center">{{ row.ContractSigned }}</td>
                                                <td class="w-100px text-center">{{ row.IsApproveUpLevel }}</td>
                                                <td class="w-100px text-center">{{ row.ComAfterTax }}</td>
                                                <td class="w-100px text-center">{{ row.CommissionAt ?
                                                    dateFormat(row.CommissionAt) : '' }}</td>
                                                <td class="w-100px text-center">{{ row.ParcelCode }}</td>
                                                <td class="w-120px text-center">

                                                    <b-button-group size="sm">
                                                        <b-button v-if="row.IsApproveUpLevel == 'Y'" variant="success"
                                                            title="ตรวจสอบประโยชน์ค่าบริหารทีม"
                                                            @click="onReqTeamManagementBenefits(row)">
                                                            <i class="fe-dollar-sign"></i></b-button>
                                                        <b-button v-if="row.OrderStatus == 'อนุมัติ'" variant="info" title="ตรวจสอบกรมธรรม์"
                                                            @click="onClickShowInspect(row)"><i
                                                                class="fe-align-justify"></i></b-button>
                                                    </b-button-group>

                                                </td>
                                            </tr>
                                            <tr v-if="!Data || Data.length === 0">
                                                <td colspan="100%" class="table-empty-note">ไม่มีข้อมูล</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <!-- end table -->
                                </div>
                            </div>
                        </div>

                        <div class="row" v-show="reqSumData.TotalSum != null">
                            <div class="col-12 text-center p-0">
                                <table class="m-auto h4 text-primary" cellpadding="4">
                                    <tr>
                                        <th class="text-right">ยอดขายที่สามารถปรับระดับ</th>
                                        <td class="text-right">{{ moneyFormatFull(reqSumData.TotalAvaiUpLevel) }}</td>
                                    </tr>
                                    <tr>
                                        <th class="text-right">ยอดขายทั้งหมด</th>
                                        <td class="text-right">{{ moneyFormatFull(reqSumData.TotalSum) }}</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <b-modal size="lg" id="bv-modal-detail" hide-footer small>
            <template #modal-title>
                ตรวจสอบประโยชน์ค่าบริหารทีม
            </template>
            <div class="d-block">
                <b-alert variant="success" show class="mb-0">
                    <div class="row p-1 text-info">
                        <div class="col-md-2 h5 text-md-right">กรมธรรม์เลขที่:</div>
                        <div class="col-md-4 h5 text-success">{{ CurrData.ContactPolicyNumber }}</div>
                        <div class="col-md-2 h5 text-md-right">ชื่อลูกค้า:</div>
                        <div class="col-md-4 h5 text-success">{{ CurrData.Firstname }} {{ getFirst1Str(CurrData.Lastname) }}</div>
                        <div class="col-md-2 h5 text-md-right">ชื่อบริษัทประกัน:</div>
                        <div class="col-md-4 h5 text-success">{{ CurrData.InsuranceTxt }}</div>
                        <div class="col-md-2 h5 text-md-right">ชื่อสมาชิกที่แจ้ง:</div>
                        <div class="col-md-4 h5 text-success">{{ CurrData.AgentId }} {{ CurrData.AgentTxt }}</div>
                    </div>
                </b-alert>

                <div class="row p-0 pt-0">
                    <div class="col-md-12">

                        <table class="table table-sm table-centered table-striped border mt-2">
                            <thead>
                                <tr>
                                    <th class="text-left">ระดับ</th>
                                    <th class="text-left">ชื่อตัวแทน</th>
                                    <th class="text-center">รหัสตัวแทน</th>
                                    <th class="text-right">ค่าบริหารทีม</th>
                                    <th class="text-center">วันที่จ่ายค่าบริหาร</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(row, idx) in DataTeamManagementBenefits" :key="idx"
                                    :class="{ 'text-warning': !row.Firstname }">
                                    <td>{{ row.CommissionLevel === 'ContractID' ? 'ผู้แนะนำ' : row.CommissionLevel }}
                                    </td>
                                    <td>{{ row.Firstname }} {{ row.Lastname }}</td>
                                    <td class="text-center">{{ row.AgentId }}</td>
                                    <td class="text-right">{{ moneyFormatFull(row.SumTotal) }}</td>
                                    <td class="text-center">{{ row.CommissionAt ? dateTimeFormat(row.CommissionAt,
                                        'DD-MM-YYYY') : '-' }}</td>
                                </tr>
                                <tr v-if="!DataTeamManagementBenefits || DataTeamManagementBenefits.length === 0">
                                    <td colspan="100%" class="table-empty-note">ไม่มีข้อมูล</td>
                                </tr>
                            </tbody>
                            <tfoot v-if="DataTeamManagementBenefits && DataTeamManagementBenefits.length > 0">
                                <tr>
                                    <th colspan="5" class="text-center p-3 font-italic">แถบตัวอักษร <span
                                            class="text-warning">สีส้ม</span> หมายถึงผู้ที่ยังไม่สมัคร AML</th>
                                </tr>
                            </tfoot>
                        </table>

                    </div>
                </div>

            </div>

        </b-modal>

        <b-modal size="xl" id="bv-modal-inspect" hide-footer small>
            <template #modal-title>
                รายละเอียด
            </template>
            <div class="d-block">
                <!-- <div class="row p-1">
                    <div class="col-md-3 text-md-right">ชื่อนายหน้า: </div>
                    <div class="col-md-3">{{ displayDataInspect.AgentTxt }}</div>
                    <div class="col-md-2 text-md-right">รหัสนายหน้า:</div>
                    <div class="col-md-2">AML{{ displayDataInspect.AgentId }}</div>
                </div> -->
                <div class="row p-1">
                    <div class="col-md-3 text-md-right">ชื่อผู้เอาประกันภัย:</div>
                    <div class="col-md-3">{{ displayDataInspect.Firstname }} {{ getFirst1Str(displayDataInspect.Lastname) }}</div>
                    <div class="col-md-2 text-md-right">กรมธรรม์เลขที่:</div>
                    <div class="col-md-2">{{ displayDataInspect.ContactPolicyNumber }}</div>
                    <div class="col-md-1 text-md-right">ปีที่:</div>
                    <div class="col-md-1">{{ displayDataInspect.Year }}</div>
                </div>
                <div class="row p-1">
                    <div class="col-md-3 text-md-right">วันที่ชำระเงิน:</div>
                    <div class="col-md-3">{{ displayDataInspect.CreatedAt != null ?
                        dateFormat(displayDataInspect.CreatedAt) :
                        '-' }}
                    </div>
                    <div class="col-md-2 text-md-right">สถานะกรมธรรม์:</div>
                    <div class="col-md-2"
                        :class="{ 'text-success': displayDataInspect.OrderStatus == 'อนุมัติ', 'text-warning': displayDataInspect.OrderStatus != 'อนุมัติ' }">
                        {{ displayDataInspect.OrderStatus }}
                    </div>

                </div>
                <div class="row p-1">
                    <div class="col-md-3 text-md-right">วันที่กรมธรรม์มีผลคุ้มครอง:</div>
                    <div class="col-md-3">{{ displayDataInspect.ContractSigned != null ?
                        dateFormat(displayDataInspect.ContractSigned) :
                        '-' }}
                    </div>
                    <div class="col-md-2 text-md-right">เลขที่พัสดุจัดส่งกรมธรรม์:</div>
                    <div class="col-md-2">{{ displayDataInspect.ParcelCode }}</div>
                </div>

                <div class="row p-1">
                    <div class="col-md-3 text-md-right">วันที่ครบกำหนดชำระงวดถัดไป:</div>
                    <div class="col-md-2" v-bind:class="{ 'text-danger': isOverDue }">{{ displayDataInspect.NextDueDate !=
                        null ?
                        dateFormat(displayDataInspect.NextDueDate) : '-' }}</div>
                </div>
                <div class="row p-1">
                    <div class="col-md-3 text-md-right">ชำระเบี้ยประกันแบบ:</div>
                    <div class="col-md-3">{{ displayDataInspect.PaymentTypeTxt }}</div>
                </div>
                <div class="row p-1">
                    <div class="col-md-3 text-md-right">เบี้ยประกันภัยรวม:</div>
                    <div class="col-md-2">{{ moneyFormatFull(displayDataInspect.PaymentAmount) }} บาท</div>
                    <!-- <div class="col-md-2 text-md-right">ค่านายหน้าที่จ่ายไป:</div>
          <div class="col-md-2">{{ moneyFormatFull(displayDataInspect.ComTotal) }} บาท</div>
          <div class="col-md-1 text-md-right">วันที่จ่าย:</div>
          <div class="col-md-2">{{ displayDataInspect.CommissionAt != null ? dateFormat(displayDataInspect.CommissionAt) : '-' }}</div> -->
                </div>

                <div class="row p-1">
                    <div class="col-md-3 text-md-right">ผู้แจ้งงาน:</div>
                    <div class="col-md-3">{{ displayDataInspect.AdminTxt }} ({{ displayDataInspect.BranchTxt }})</div>
                </div>

                <div class="row p-1">
                    <div class="col-md-12">
                        <Label>ข้อมูลสัญญา</Label>

                        <table class="table table-centered table-striped border mt-2">
                            <thead>
                                <tr>
                                    <th>บริษัท</th>
                                    <th>ชื่อสัญญา</th>
                                    <th>ประเภท</th>
                                    <th class="text-right">เบี้ย</th>
                                    <!-- <th class="text-right">ค่านายหน้า (%)</th> -->
                                    <!-- <th class="text-right">จำนวนเงินค่านายหน้า</th> -->
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="pack in CurrentOrderPackages" :key="pack.OrderPackageId">
                                    <td>{{ displayDataInspect.InsuranceTxt }}</td>
                                    <td>{{ pack.ContractName }}</td>
                                    <td>{{ pack.ContractType == 1 ? 'สัญญาหลัก' : 'สัญญาเพิ่มเติม' }}</td>
                                    <td class="text-right">{{ moneyFormatFull(pack.Price) }}</td>
                                    <!-- <td class="text-right">{{ moneyFormatFull(pack.CommissionRate * 100) }}</td> -->
                                    <!-- <td class="text-right">{{ moneyFormatFull(pack.ComPrice) }}</td> -->
                                </tr>
                                <tr v-if="!CurrentOrderPackages || CurrentOrderPackages.length === 0">
                                    <td colspan="100%" class="table-empty-note">ไม่มีข้อมูล</td>
                                </tr>
                            </tbody>
                        </table>

                    </div>
                </div>

                <div class="row p-1">
                    <div class="col-md-12">
                        <Label>ข้อมูลการจ่ายเงิน</Label>

                        <table class="table table-centered table-striped border mt-2">
                            <thead>
                                <tr>
                                    <th>งวดที่</th>
                                    <th>วันครบกำหนดชำระ</th>
                                    <th>วันที่ชำระเบี้ย</th>
                                    <th class="text-right">ชำระ</th>
                                    <th class="text-right">ผลประโยชน์ที่จ่ายจริง(หลังหักภาษี)</th>
                                    <th class="text-center">วันที่จ่าย(คอม)</th>
                                    <!-- <th class="text-Wleft">ผลงานของ</th> -->
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="pay in CurrentOrderPayment.filter(c=>c.CommissionStatus == 1)" :key="pay.Period">
                                    <td>{{ pay.Period }}</td>
                                    <td class="text-left">{{ dateFormat(pay.DueDateAt) }}</td>
                                    <td class="text-left">{{ pay.PaymentAt == null ? '' : dateFormat(pay.PaymentAt) }}
                                    </td>
                                    <td class="text-right">{{ pay.Payment == 0 ? '' : moneyFormatFull(pay.Payment) }}
                                    </td>
                                    <td class="text-right">{{ pay.CommissionAt == null ? '' :
                                        moneyFormatFull(pay.ComTotal) }}
                                    </td>
                                    <td class="text-center">{{ (pay.CommissionStatus == 0 && pay.CommissionAt != null) ?
                                        'กำลังดำเนินการ' :
                                        (pay.CommissionAt == null ? '' : dateFormat(pay.CommissionAt)) }}</td>
                                    <!-- <td class="text-left">{{ pay.BranchTxt }}</td> -->
                                </tr>
                                <tr v-if="!CurrentOrderPayment || CurrentOrderPayment.filter(c=>c.CommissionStatus == 1).length === 0">
                                    <td colspan="100%" class="table-empty-note">ไม่มีข้อมูล</td>
                                </tr>
                            </tbody>
                        </table>

                    </div>
                </div>
            </div>

        </b-modal>
    </Layout>
</template>

<script>
import Layout from '@/components/layouts/main'
import PageHeader from '@/components/page-header'

let self;
/**
 * Customers component
 */
export default {
    page: {
        title: 'รายการงานแจ้งงานส่วนตัว',
        meta: [{ name: 'description' }],
    },
    components: {
        Layout,
        PageHeader,
    },
    data() {
        var yup = this.yup
        return {
            title: 'รายการงานแจ้งงานส่วนตัว',
            items: [
                {
                    text: 'SKLife',
                    to: { name: 'home' }
                },
                {
                    text: 'รายการงานแจ้งงานส่วนตัว',
                    active: true
                },
            ],
            settings: {
                maxScrollbarLength: 600
            },

            VUE_APP_OFFICEAPI_URL: process.env.VUE_APP_OFFICEAPI_URL,
            isReqCmd: "",
            isDownload: false,
            isDownloadReqSum: false,
            reqSumData: {
                TotalSum: null,
                TotalAvaiUpLevel: null
            },
            MasterInsuranceComp: [],
            MasterDateCriteria: [
                { id: 'ContactCreateDate', value: 'วันที่แจ้งงาน' },
                { id: 'ContactSinged', value: 'วันที่คุ้มครอง' },
                { id: 'CommissionAt', value: 'วันที่คืนคอมมิชชั่น' },
                { id: 'NextDueDate', value: 'วันที่ครบกำหนดชำระงวดถัดไป' },
            ],
            dataDueDateIn: [{ id: '15', value: '15 วัน' }, { id: '30', value: '30 วัน' }, { id: '60', value: '60 วัน' }],
            Data: [],
            DataTeamManagementBenefits: [],
            CurrData: {},
            CurrentOrderPackages: [],
            CurrentOrderPayment: [],
            displayDataInspect: [],
            isOverDue: false,
            filter: {
                AgentId: "",
                InsuranceId: '',
                ContractPolicy: '',
                Firstname: '',
                Lastname: '',
                DateStart: this.$dayjs().format('YYYY-MM-DD'),
                DateEnd: this.$dayjs().format('YYYY-MM-DD'),
                InsuranceTypeOrdinary: "Y",
                InsuranceTypeGroup: "Y",
                IsPendingStatus: "N",
                NextDueDateIn: "",
                DateCriteria: "",
                PerPage: 10,
                CurrentPage: 1,
            },
            errors: {
                AgentId: "",
                ContractPolicy: '',
                DateStart: "",
                DateEnd: "",
                InsuranceId: '',
                Firstname: '',
                Lastname: '',
                InsuranceTypeOrdinary: "",
                InsuranceTypeGroup: "",
                IsPendingStatus: "",
                NextDueDateIn: "",
                DateCriteria: "",
            },
            FormSchema: yup.object().shape({
                AgentId: yup.string().test('empty-check', 'ค้นหาไม่น้อยกว่า 4 ตัวอักษร', AgentId => AgentId.length >= 4),
                InsuranceId: yup.string().nullable(),
                ContractPolicy: yup.string().nullable(),
                Firstname: yup.string().nullable(),
                Lastname: yup.string().nullable(),
                DateStart: yup.string().required('กรุณาระบุวันที่จ่ายเงิน'),
                DateEnd: yup.string().required('กรุณาระบุวันที่จ่ายเงิน'),
                InsuranceTypeOrdinary: yup.string().nullable(),
                InsuranceTypeGroup: yup.string().nullable(),
                IsPendingStatus: yup.string().nullable(),
                NextDueDateIn: yup.string().nullable(),
                DateCriteria: yup.string().required('กรุณาเลือกวันที่ แจ้งงาน/คุ้มครอง/คืนคอมฯ'),
            }),

        }
    },
    async created() {
        self = this;
        //this.$store.state.Admin.Id

        if (this.$store.state.Admin.IsForceChangePwd)
            this.$router.push({ name: 'admin-change-password' });
    },
    async mounted() {
        this.getAgentId();
        this.getInsurance();
    },
    methods: {
        scrollHandle(evt) {
            console.log(evt)
        },
        submitReqSum() {
            console.log('submitDownload');
            self.isReqCmd = "REQSUM";
            this.validateForm();
        },
        submitDownload() {
            self.isReqCmd = "REQDOWNLOAD";
            this.validateForm();
        },
        validateForm() {
            this.FormSchema
                .validate(this.filter, { abortEarly: false })
                .then(() => {
                    if (self.isReqCmd == "REQDOWNLOAD")
                        this.downloadExcel(this.filter);
                    else if (self.isReqCmd == "REQSUM")
                        this.reqSum(this.filter);
                })
                .catch(err => {
                    err.inner.forEach(error => {
                        this.errors = { ...this.errors, [error.path]: error.message };
                    });
                });
        },
        validate(field) {
            this.FormSchema
                .validateAt(field, this.filter)
                .then(() => {
                    this.errors[field] = "";
                })
                .catch(err => {
                    this.errors[err.path] = err.message;
                });
        },
        async getAgentId() {
            this.isBusy = true
            const config = {
                headers: { Authorization: `Bearer ${this.$store.state.Admin.Token}` },
            };
            await this.axios.get(process.env.VUE_APP_OFFICEAPI_URL + '/api/whtc/getagentid/' + this.$store.state.Admin.RefId, config)
                .then(function (res) {
                    if (res.status == 200) {
                        self.filter.AgentId = res.data;
                    } else {
                        self.$swal('เกิดข้อผิดพลาด');
                    }
                    self.isBusy = false
                })
                .catch(function (error) {
                    self.$swal('เกิดข้อผิดพลาด');
                    self.isBusy = false
                });
        },
        async getInsurance() {
            this.isBusy = true
            const config = {
                headers: { Authorization: `Bearer ${this.$store.state.Admin.Token}` },
            };
            await this.axios.get(process.env.VUE_APP_OFFICEAPI_URL + '/api/center/getinsurance', config)
                .then(function (res) {
                    if (res.status == 200) {
                        self.MasterInsuranceComp = res.data.map((c) => { return { id: c.Id, value: c.FullName } });
                    } else {
                        self.$swal('เกิดข้อผิดพลาด');
                    }
                    self.isBusy = false
                })
                .catch(function (error) {
                    self.$swal('เกิดข้อผิดพลาด');
                    self.isBusy = false
                });
        },
        downloadExcel(filter) {
            try {
                self.isDownload = true;
                const config = {
                    headers: { Authorization: `Bearer ${self.$store.state.Admin.Token}` },
                    responseType: 'blob',
                    params: filter
                };
                this.axios.get(process.env.VUE_APP_OFFICEAPI_URL + '/api/report/download', config)
                    .then(function (res) {
                        if (res.status == 200) {
                            const filename = `AgentOrderReport_${self.filter.AgentId}_${self.filter.DateStart}.xlsx`;
                            self.saveAs(res.data, filename);
                        }
                        self.isDownload = false;
                    })
                    .catch(function (error) {
                        self.isDownload = false;
                    });
            } catch (error) {
                return null
            }
        },
        reqSum(filter) {

            try {
                self.isDownloadReqSum = true;
                const config = {
                    headers: { Authorization: `Bearer ${self.$store.state.Admin.Token}` },
                    params: filter
                };
                this.axios.get(process.env.VUE_APP_OFFICEAPI_URL + '/api/report/getorderpersonal', config)
                    .then(function (res) {
                        if (res.status == 200) {
                            //console.log(res.data);
                            self.reqSumData = res.data.Option;
                            self.Data = res.data.Data;
                        } else {
                            self.$swal({ icon: 'info', text: 'ไม่มีข้อมูล' });
                        }
                        self.isDownloadReqSum = false;
                    })
                    .catch(function (error) {
                        self.$swal({ icon: 'info', text: 'ไม่มีข้อมูล' });
                        self.isDownloadReqSum = false;
                    });
            } catch (error) {
                return null
            }
        },

        onReqTeamManagementBenefits(row) {
            try {
                self.isDownloadReqSum = true;
                const config = {
                    headers: { Authorization: `Bearer ${self.$store.state.Admin.Token}` },
                    params: { ContractPolicyNumber: row.ContactPolicyNumber }
                };
                this.axios.get(process.env.VUE_APP_OFFICEAPI_URL + '/api/TeamManagementBenefits', config)
                    .then(function (res) {
                        if (res.status == 200) {
                            //console.log(res.data);
                            self.DataTeamManagementBenefits = res.data.Data;
                            self.CurrData = row;
                            self.$bvModal.show('bv-modal-detail');

                        } else {
                            self.$swal({ icon: 'info', text: 'ไม่มีข้อมูล' });
                        }
                        self.isDownloadReqSum = false;
                    })
                    .catch(function (error) {
                        self.$swal({ icon: 'info', text: 'ไม่มีข้อมูล' });
                        self.isDownloadReqSum = false;
                    });
            } catch (error) {
                return null
            }
        },


        async onClickShowInspect(currentRow) {

            //console.log('currentRow', currentRow)

            let date1 = this.$dayjs(currentRow.NextDueDate);
            let date2 = this.$dayjs();
            self.isOverDue = date1.diff(date2) < 0;

            const config = {
                headers: { Authorization: `Bearer ${this.$store.state.Admin.Token}` }
            };

            await this.axios.get(process.env.VUE_APP_OFFICEAPI_URL + '/api/orderpackageyear/getorderpackageyear/' + currentRow.OrderId + '/' + currentRow.Year, config)
                .then(function (res) {
                    if (res.status == 200) {
                        //console.log(res)
                        self.CurrentOrderPackages = res.data

                        //console.log('aaaa', res.data)
                    } else {
                        self.$swal('เกิดข้อผิดพลาด1');
                    }
                })
                .catch(function (error) {
                    console.log(error)
                    self.$swal('เกิดข้อผิดพลาด2');
                });

            await this.axios.get(process.env.VUE_APP_OFFICEAPI_URL + '/api/order/getordercheckpayment?OrderId=' + currentRow.OrderId, config)
                .then(function (res) {
                    if (res.status == 200) {
                        //console.log(res)
                        self.CurrentOrderPayment = res.data

                        self.displayDataInspect = currentRow;
                        self.$bvModal.show('bv-modal-inspect');

                        //console.log('bbbb', res.data)
                    } else {
                        self.$swal('เกิดข้อผิดพลาด1');
                    }
                })
                .catch(function (error) {
                    console.log(error)
                    self.$swal('เกิดข้อผิดพลาด2');
                });
        },

    },
    watch: {
        // 'filter.AgentId': {
        //     handler: function () {
        //         self.reqSumData = { TotalSum: null, TotalAvaiUpLevel: null };
        //     }
        // },
        'filter.DateStart': {
            handler: function () {
                self.reqSumData = { TotalSum: null, TotalAvaiUpLevel: null };

                if (this.filter.DateStart > this.filter.DateEnd)
                    this.filter.DateEnd = this.filter.DateStart;
            }
        },
        'filter.DateEnd': {
            handler: function () {
                self.reqSumData = { TotalSum: null, TotalAvaiUpLevel: null };

                if (this.filter.DateStart > this.filter.DateEnd)
                    this.filter.DateStart = this.filter.DateEnd;
            }
        },

    }
}
</script>